module.exports = __webpack_public_path__ + "img/hook_MARTEC_OKE_2.82c1e4d0.png";